module.exports = __webpack_public_path__ + "img/geotextil1.4e60a118.png";